import { t } from 'ember-intl';
import { PhFilePdf } from 'ember-phosphor-icons';
import type { TOC } from '@ember/component/template-only';
import type { TasAssetExtension as TasAssetModel } from 'tio-data/data/resources/tas-asset.ext';

interface DiscardedListSignature {
  Args: {
    /** Soft-removed assets within the current step. Empty array → render nothing. */
    assets: TasAssetModel[];
  };
  Element: HTMLDivElement;
}

/**
 * "Discarded:" tray below the document rows. Persists discarded files for the
 * remainder of the wizard session so the employee has an audit trail of what
 * they tried to upload (Figma frames B5–B9).
 *
 * Renders nothing when `assets` is empty so it stays out of the way until the
 * employee actually discards something.
 */
const DiscardedList: TOC<DiscardedListSignature> = <template>
  {{#if @assets.length}}
    <div
      class="tio-cluster-tight rounded tio-bg-sunken px-3 py-2 text-xs"
      data-test-discarded-list
      ...attributes
    >
      <span class="font-semibold tio-fg-muted">
        {{t "tas.attachments.discarded"}}
      </span>
      {{#each @assets as |asset|}}
        <span
          class="tio-inline-row gap-1.5 rounded border tio-border-default tio-bg-surface px-2 py-1 tio-fg-muted line-through"
          title={{asset.filename}}
        >
          <PhFilePdf @size="12" class="shrink-0" />
          <span class="truncate max-w-[14rem]">{{asset.filename}}</span>
        </span>
      {{/each}}
    </div>
  {{/if}}
</template>;

export default DiscardedList;
